import objectToFormData from 'object-to-form-data';
const request =
{
	requestURL: (method, url, data, options) =>
	{
		const href = window.location.href;
		const hash = window.location.hash;
		
		url = new URL(url || href.substring(0, href.length - hash.length), window.location);
		
		const requestPromise = new Promise((resolve, reject) =>
		{
			options = Object.assign(
			{
				method: method,
				mode: 'same-origin',
				cache: 'no-cache',
				credentials: 'same-origin',
				headers:
				{
					// 'Content-Type': 'application/json',
					'Accept': 'application/json, application/jsonl, text/html',
					// 'Content-Type': 'application/x-www-form-urlencoded'
				},
				redirect: 'follow',
				referrerPolicy: 'no-referrer'
			}, options);
			
			if(options.method === 'POST')
			{
				if(!(data instanceof FormData)) data = objectToFormData(data);
				
				// options.body = new URLSearchParams(data);
				options.body = data;
			}
			else
			{
				const searchData = new URLSearchParams(data);
				
				url.search = searchData.toString();
			}

			const handleResponse = (response) =>
			{
				const contentTypes = (response.headers.get('Content-Type') || '').split('; ');
				
				if(contentTypes.indexOf('application/json') !== -1)
				{
					response.json().then(json =>
					{
						resolve(json, response);
					});
				}
				else if(contentTypes.indexOf('text/html') !== -1)
				{
					response.text().then(text =>
					{
						resolve(text, response);
					})
				}
				else if(contentTypes.indexOf('application/jsonl') !== -1)
				{
					const reader = response.body.getReader();
					
					const utf8decoder = new TextDecoder(); // default 'utf-8' or 'utf8'

					const dataDecode = (value) =>
					{
						try
						{
							return [JSON.parse(value), null];
						}
						catch(e)
						{
							console.error(e);
							return [null, e];
						}
					};
					
					var buffer = '';
					
					const rStream = new ReadableStream(
					{
						start(controller)
						{
							// The following function handles each data chunk
							function push()
							{
								// "done" is a Boolean and value a "Uint8Array"
								reader.read().then(({ done, value }) =>
								{
									if (done)
									{
										console.debug('Done');
      									if (buffer.trim())
										{
											const [decodedData, error] = dataDecode(buffer);

											if(error) console.error(error);

											console.debug('enqueue last', decodedData);
											controller.enqueue(decodedData);
										}

										controller.close();
      									return;
    								}

    								buffer += utf8decoder.decode(value, { stream: true });

    								const lines = buffer.split('\n');
    								
    								// Process all complete lines
    								for (let i = 0; i < lines.length - 1; i++)
									{
      									const line = lines[i].trim();
      									if (line)
										{
											const [decodedData, error] = dataDecode(line);

											if(error) console.error(error);

											console.debug('enqueue', decodedData);
											controller.enqueue(decodedData);
										}
    								}

    								// Keep the last potentially incomplete line in the buffer
    								buffer = lines[lines.length - 1];

									push();
								});
							}
							
							push();
						},
					});
					
					const res = new Response(rStream, { headers: {'Content-Type': 'text/html'}});
					
					resolve(res.body.getReader());
				}
				else if(contentTypes.indexOf('application/octet-stream') !== -1)
				{
					const reader = response.body.getReader();
					
					const utf8decoder = new TextDecoder(); // default 'utf-8' or 'utf8'
					
					const rStream = new ReadableStream(
					{
						start(controller)
						{
							// The following function handles each data chunk
							function push()
							{
								// "done" is a Boolean and value a "Uint8Array"
								reader.read().then(({ done, value }) =>
								{
    								const dataChunk = utf8decoder.decode(value, { stream: true });
									controller.enqueue(dataChunk);

									if (done)
									{
										console.debug('Done');

										controller.close();

										return;
    								}

									push();
								});
							}
							
							push();
						},
					});
					
					const res = new Response(rStream, { headers: {'Content-Type': 'text/html'}});
					
					resolve(res.body.getReader());
				}
				else
				{
					throw "Received unknown content type. (" + contentTypes.join('; ') + ')';
				}
			};
			
			fetch(url, options).then(handleResponse).catch(handleResponse);
		});
		
		return requestPromise;
	},
	postURL: (url, data, options) =>
	{
		return request.requestURL('POST', url, data, options);
	},
	post: (data, options) =>
	{	//2014-03-17
		return request.postURL(null, data, options);
	},
	getURL: (url, data, options) =>
	{	//2018-02-07
		return request.requestURL('GET', url, data, options);
	},
	get: (data, options) =>
	{	//2018-02-07
		return request.getURL(null, data, options);
	}
};

export default request;
